import * as React from "react";
import Collapse from "@mui/material/Collapse";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { rows } from "../../utils/table_data";
import CollapseContent from "./CollapseContent";
import { StyledTableCell, StyledTableRow } from "../../molecules/TableStyle";
import { useMediaQuery } from "@mui/material";

function Row(props) {
  const matches = useMediaQuery("(max-width:720px)");
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <StyledTableRow
        className="cursor-pointer "
        onClick={() => setOpen(!open)}
      >
        <StyledTableCell align="left" font={matches ? 13 : ""}>
          <div className="text-center bg-blue/10 text-deep-blue border border-1 border-deep-blue/80 rounded-lg px-4 py-2">
            {row.part_number}
          </div>
        </StyledTableCell>
        <StyledTableCell font={matches ? 13 : ""} align="left">
          {row.sub_category}
        </StyledTableCell>
        <StyledTableCell font={matches ? 13 : ""} align="left">
          {row.description}
        </StyledTableCell>
        <StyledTableCell font={matches ? 13 : ""} align="left">
          {row.manufacturer}
        </StyledTableCell>
        <StyledTableCell font={matches ? 13 : ""} align="left">
          {row.price}
        </StyledTableCell>
      </StyledTableRow>
      <TableRow>
        <StyledTableCell
          font={matches ? 13 : ""}
          style={{ paddingBottom: 0, paddingTop: 0 }}
          colSpan={6}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <CollapseContent item={row} />
          </Collapse>
        </StyledTableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function CollapseTable() {
  const matches = useMediaQuery("(max-width:720px)");
  return (
    <TableContainer
      sx={{ boxShadow: "none" }}
      component={Paper}
      className="max-h-[350px] md:max-h-[560px] shadow-none overflow-scroll"
    >
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <StyledTableCell
              font={matches ? 14 : ""}
              className="bg-light/50 mr-2 "
            >
              part number
            </StyledTableCell>
            <StyledTableCell
              font={matches ? 14 : ""}
              align="left"
              className="bg-light/50 mr-2"
            >
              sub category <KeyboardArrowDownIcon />{" "}
            </StyledTableCell>
            <StyledTableCell
              align="left"
              wide={true}
              className="bg-light/50 mr-2"
            >
              description
            </StyledTableCell>
            <StyledTableCell
              font={matches ? 14 : ""}
              align="left"
              className="bg-light/50 mr-2"
            >
              manufacturer
            </StyledTableCell>
            <StyledTableCell
              font={matches ? 14 : ""}
              align="left"
              className="bg-light/50 mr-2"
            >
              price
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <Row key={i} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
